import { render, staticRenderFns } from "./card-cigar.vue?vue&type=template&id=bf71ce36&scoped=true&"
import script from "./card-cigar.vue?vue&type=script&lang=js&"
export * from "./card-cigar.vue?vue&type=script&lang=js&"
import style0 from "./card-cigar.vue?vue&type=style&index=0&id=bf71ce36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71ce36",
  null
  
)

export default component.exports